import React from "react";
import {Tabs, Tab, Box} from "@mui/material";
import {RecentOrders} from "./RecentOrders";
import {DeliveredOrders} from "./DeliveredOrders";
import {HubOrders} from "./HubOrders";
import {ExecutingOrders} from "./ExecutingOrders";
import {DraftOrders} from "./DraftOrders";

export default function OrderTab() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabs = [
    {
      label: "Orders",
      value: "recent",
      component: <RecentOrders />,
    },
    {
      label: "Draft",
      value: "draft",
      component: <DraftOrders />,
    },
    {
      label: "In hub",
      value: "hub",
      component: <HubOrders />,
    },
    {
      label: "Executing",
      value: "executing",
      component: <ExecutingOrders />,
    },

    {
      label: "Completed",
      value: "completed",
      component: <DeliveredOrders />,
    },
  ];

  return (
    <Box
      sx={{
        height: "100%",
        width: "92%",
        margin: "24px auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "#E2E2E2",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#4B5563",
              height: 2,
            },
          }}
        >
          {tabs.map(({label}, index) => (
            <Tab
              key={index}
              label={label}
              sx={{
                fontWeight: "bold",
                fontSize: "1rem",
                textTransform: "none",
                color: value === index ? "#4B5563" : "#9CA3AF", // gray-700 and gray-400
                minWidth: 0,
                padding: "0 16px 12px",
                marginRight: "16px",
                "&.Mui-selected": {
                  color: "#4B5563",
                },
              }}
            />
          ))}
        </Tabs>

        {/* <Link
          to={"/orders/create"}
          className="rounded-lg !py-2 !px-4 !text-white !bg-orange-500 !text-sm !font-semibold !mb-1"
        >
          Create order
        </Link> */}
      </Box>

      <Box sx={{mt: 3, flex: 1}}>
        {tabs.map(({component}, index) => (
          <div
            key={index}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
          >
            {value === index && component}
          </div>
        ))}
      </Box>
    </Box>
  );
}
